import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import moment from 'moment';
import {
    CONTRACT_SCREEN_MANAGEMENT,
    CONTRACT_STATUS,
    MONTH,
    PAYMENT_CYCLE_LIST,
    YEAR
} from '@/common/constant/NormalContractManagementConstant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import { getListProductManagement, getProductById } from '@/service/productManagementService';
import { updateCorporationContractDetail } from '@/service/contractService'
import { hanldeValidateInputSubmit } from './common/ContractHandler';

const handlePaymentMethod = async (
    API,
    updateDto,
    setIsLoading,
    enqueueSnackbar,
    setIsShowPopUpReload,
    product,
    edition,
    version,
    paymentCycle,
    payment,
    currentVersionInfo,
    basicSetting,
    advancedSetting,
    setNextScreen,
    setTriggerReload
) => {
    setIsLoading(true);
    let data = {
        currentVersionId: currentVersionInfo.id,
        newVersionId: version.id,
        newEditionId: edition.id,
        newProductId: product.id,
        paymentCycle: paymentCycle.code,
        newVersionUpdatedAt: currentVersionInfo.updatedAt
    }

    let additionalUpgradeSetting = {
        maxNumOfGeneralUser: basicSetting?.numOfGeneralUser?.quantity?.update || 0,
        numOfSetTicket: advancedSetting.numOfTicket?.quantity?.update || 0,
        numOfSetKnowledge: advancedSetting?.numOfTicketKnowledge?.quantity?.update || 0,
        numOfSetStorage: advancedSetting?.numOfStorage?.quantity?.update || 0,
        numOfSetQACounter: advancedSetting?.numberOfQACounters?.quantity?.update || 0,
        numOfSetSupportCounter: advancedSetting?.numberOfSupportedCounters?.quantity?.update || 0
    }

    updateDto.data = JSON.stringify(data);
    const paymentDiscount = localStorage.getItem('discountContract') ? Number(localStorage.getItem('discountContract')) : 0;
    updateDto.currentTotalPrice = payment - paymentDiscount;
    updateDto.additionalUpgradeSetting = JSON.stringify(additionalUpgradeSetting)

    let res = await updateCorporationContractDetail(API, updateDto);

    if(!res.status) {
        setIsLoading(false);
        setIsShowPopUpReload({isOpen: true, message: res?.errors});
        return;
    }

    switch (updateDto.method) {
        case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.CREDIT:
            let dataStripe = Utils.convertJSONDataToObject(res?.data);
            setIsLoading(false);
            if(dataStripe?.url && dataStripe?.isRedirect) {
                window.location.href = dataStripe?.url;
            }
            break;
        case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.BANK_TRANSFER:
            setIsLoading(false);
            break;
        default:
            break;
    }

    if (res.status) {
        enqueueSnackbar(I18n.get('MSG-CM-UPDATE-DATA-SUCCESS'), {
            variant: 'success',
            autoHideDuration: 3000
        });
        setIsLoading(false);
        setNextScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN);
        setTriggerReload(Date.now().toString());
    }
};

const hanldeBtnUpdateContractSubmit = (
    contractDetail, 
    setCheckErr, 
    updateContractData, 
    setBasicSetting,
    setAdvanceSetting,
    setNextScreen
) => {
    const validate = hanldeValidateInputSubmit(contractDetail, updateContractData);

    if (!validate.isValid) {
        setCheckErr(false);
        return setNextScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.SCREEN);
    }

    setBasicSetting({...validate.resultValid.basicSetting});
    setAdvanceSetting({...validate.resultValid.advanceSetting});
}
export const handleRedirect = async(
    curentScreen,
    setNextScreen,
    btnType,
    setOpenPolicy,
    updateDto,
    enqueueSnackbar,
    API,
    setIsLoading,
    setCheckErr,
    contractDetail,
    updateContractData,
    setBasicSetting,
    setAdvanceSetting,
    setIsShowPopUpReload,
    product,
    edition,
    version,
    paymentCycle,
    payment,
    currentVersionInfo,
    basicSetting,
    advanceSetting,
    isUpdateConfirm,
    setIsShowPopupCancel,
    hanldeCloseUpdateContract,
    setTriggerReload
) => {
    switch (curentScreen) {
        case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN:
            switch (btnType) {
                case I18n.get('CM-BUTTON-PAYEMENT-MANAGEMENT'):
                    break;
                case I18n.get('CM-BUTTON-CONTRACT-HISTORY'):
                    break;
                case I18n.get('CM-BUTTON-UPDATE-CONTRACT'):
                    setNextScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN);
                    break;
                default:
                    break;
            }
            break;
        case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN:
            switch (btnType) {
                case I18n.get('CM-BUTTON-CANCEL'):
                    // if (isUpdateConfirm) {
                    //     return setIsShowPopupCancel(true);
                    // } // popup cancel: if change data, it will display --> current hidden because outscoped
                    hanldeCloseUpdateContract();
                    setCheckErr(false);
                    setNextScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_VIEW_DETAIL.SCREEN);
                    break;
                case I18n.get('CM-BUTTON-SAVE-AS-DRAFT'):
                    break;
                case I18n.get('CM-BUTTON-EXPORT-QUOTATION'):
                    break;
                case I18n.get('CM-BUTTON-UPDATE'):
                    hanldeBtnUpdateContractSubmit(
                        contractDetail, 
                        setCheckErr, 
                        updateContractData, 
                        setBasicSetting,
                        setAdvanceSetting,
                        setNextScreen
                    );
                    break;
                default:
                    break;
            }
            break;
        case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.SCREEN:
            switch (btnType) {
                case I18n.get('CM-BUTTON-CANCEL'):
                    setNextScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN);
                    break;
                case I18n.get('CM-BUTTON-EXPORT-QUOTATION'):
                    break;
                case I18n.get('CM-BUTTON-CONFIRM'):
                    // setNextScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.SCREEN)
                    setOpenPolicy(true);
                    break;
                default:
                    break;
            }
            break;
        case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.SCREEN:
            switch (btnType) {
                case I18n.get('CM-BUTTON-CANCEL'):
                    setNextScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN);
                    break;
                case I18n.get('CM-BUTTON-CONFIRM'):
                    await handlePaymentMethod(
                        API,
                        updateDto,
                        setIsLoading,
                        enqueueSnackbar,
                        setIsShowPopUpReload,
                        product,
                        edition,
                        version,
                        paymentCycle,
                        payment,
                        currentVersionInfo,
                        basicSetting,
                        advanceSetting,
                        setNextScreen,
                        setTriggerReload
                    );
                    break;
                default:
                    break;
            }
            break;
        default:
            break;
    }
};

export const hanldeShowDialogPolicy = (isOpenPolicy, setOpenPolicy, setCurrentScreen, kind) => {
    setOpenPolicy(!isOpenPolicy);
    switch(kind) {
        case CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE_CONFRIM.LABEL.KIND_BACK:
            setCurrentScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN);
            break;
        default:
            setCurrentScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.SCREEN);
            break;
    }
}

const getNameProduct = (name, edit_name, isTrial) => {
    let nameProduct = name;

    if (!Utils.isEmptyString(edit_name)) {
        let trial = '';
        if (isTrial == CONTRACT_STATUS.TRIAL) {
            trial = ` (${I18n.get('LABEL-TABLE-ELECT-TRIAL-EDITION')})`;
        }
        nameProduct += ` (${edit_name + trial})`;
    }
    return nameProduct;
};

export const currentContract = contractDetail => {
    return [
        {
            label: I18n.get('LABEL-CURRENT-CONTRACT'),
            content: getNameProduct(
                contractDetail?.productData?.name,
                contractDetail?.editionData?.name,
                contractDetail?.contractDetail?.contractStatus
            ),
            isNameProduct: true
        },
        {
            label: I18n.get('LABEL-TOTAL-PAYMENT-AMOUNT'),
            content: '0円'
        },
        {
            label: I18n.get('LABEL-EXPIRATION-DATE'),
            content: moment(contractDetail?.corporationData?.lastDayOfContract).format(
                'YYYY年MM月DD日'
            )
        }
    ];
};

const sumTotalMaxUsing = (max, maxAdvance = '', isMultipliedByGeneralUser = false, purchasedGenericIDNumber = 1) => {
    if (isMultipliedByGeneralUser) {
        return (Number(max) * purchasedGenericIDNumber) || 0;
        // return (Number(max) * purchasedGenericIDNumber) + Number(maxAdvance) || 0; // Has not processed the purchase section so comment
    }

    // if (!Utils.isEmptyString(maxAdvance)) { // Has not processed the purchase section so comment
    //     return Number(max) + Number(maxAdvance) || 0;
    // }

    return Number(max) || 0; 
}

export const usingStageStatus = (corporationData, contractDetail, versionDetail) => {
    const limitValue = contractDetail?.limitValue;
    let storageLimitValue = Utils.convertByteToGigaByte(limitValue?.maxNumOfStorage, 6) || 0;
    let usedStorage = Utils.convertByteToGigaByte(corporationData?.limitValue?.numOfStorage, 6) || 0;
    storageLimitValue = parseFloat((Number(storageLimitValue)).toFixed(3));
    usedStorage = parseFloat((Number(usedStorage)).toFixed(3));

    // comment for now
    // out of scope. it will be added in next sprints.
    // const usedExternalAPICalls = parseInt(
    //     Number(corporationData?.limitValue?.numberOfExternalAPICalls || 0)
    // );
    // const settingExternalAPI = {
    //     label: I18n.get('LABEL-USED-EXTERNAL-WEB-API'),
    //     subLabel: I18n.get('LABEL-CALLS'),
    //     used: usedExternalAPICalls,
    //     limit: limitValue?.maxNumberOfExternalAPICalls || 0,
    //     custom: false,
    //     enable: !!corporationData?.limitValue?.externalWebAPI
    // };
    return [
        {
            label: I18n.get('LABEL-NUMBER-OF-USED-TICKET'),
            subLabel: I18n.get('LABEL-NUMBER'),
            used: corporationData?.limitValue?.numOfTicket,
            limit: limitValue?.maxNumOfTicket || 0,
            custom: false,
            enable: true,
        },
        {
            label: I18n.get('LABEL-NUMBER-OF-USED-KNOWLEDGE'),
            subLabel: I18n.get('LABEL-NUMBER'),
            used: corporationData?.limitValue?.numOfTicketKnowledge,
            limit: limitValue?.maxNumOfTicketKnowledge || 0,
            custom: false,
            enable: corporationData?.knowledgeService ? true : false,
        },
        {
            label: I18n.get('LABEL-NUMBER-OF-GENERAL-PRJ'),
            subLabel: I18n.get('LABEL-NUMBER'),
            used: corporationData?.limitValue?.numOfGeneralProject,
            limit: limitValue?.maxNumOfGeneralProject || 0,
            custom: false,
            enable: true,
        },
        {
            label: I18n.get('LABEL-Q&A-COUNTER-NUMBER'),
            subLabel: I18n.get('LABEL-NUMBER'),
            used: corporationData?.limitValue?.numOfGuestDesk,
            limit: corporationData?.limitValue?.maxNumOfGuestDesk || 0,
            custom: false,
            enable: true,
        },
        {
            label: I18n.get('LABEL-SUPPORT-COUNTER-NUMBER'),
            subLabel: I18n.get('LABEL-NUMBER'),
            used: corporationData?.limitValue?.numOfGuestProject,
            limit: corporationData?.limitValue?.maxNumOfGuestProject || 0,
            custom: false,
            enable: corporationData?.deskService ? true : false,
        },
        {
            label: I18n.get('LABEL-NUMBER-OF-INTERNAL-CUSTOMER'),
            subLabel: I18n.get('LABEL-ID'),
            used: corporationData?.limitValue?.numOfInternalUser,
            limit: limitValue?.maxNumOfInternalUser || 0,
            custom: false,
            enable: true,
        },
        {
            label: I18n.get('LABEL-NUMBER-OF-B2C'),
            subLabel: I18n.get('LABEL-ID'),
            used: corporationData?.limitValue?.numOfB2CCustomer,
            limit: limitValue?.maxNumOfB2CCustomer || 0,
            custom: false,
            enable: corporationData?.deskService ? true : false,
        },
        {
            label: I18n.get('LABEL-USED-STORAGE'),
            subLabel: I18n.get('LABEL-GB'),
            used: usedStorage,
            limit: storageLimitValue || 0,
            custom: false,
            enable: true,
        }
    ];
};

export const usingFunctions = (corpLimitValue, corporationData) => {

    if(Utils.isEmptyObject(corpLimitValue)) return [];
    let listUsingFunctions = [
        {
            label: I18n.get('LABEL-FUNCTION-PUBLIC-SERVICE-DESK-SETTINGS'),
            status: corporationData?.deskService
        },
        {
            label: I18n.get('LABEL-FUNCTION-PUBLIC-WEB-FORM'),
            status: corpLimitValue.publicWebForm
        },
        {
            label: I18n.get('LABEL-FUNCTION-EMAIL-RESPONSE-FUNCTION'),
            status: corpLimitValue.emailResponseFunction
        },
        {
            label: I18n.get('LABEL-FUNCTION-SOLUTIONDESK-KNOWLEDGE'),
            status: corporationData?.knowledgeService
        },
        {
            label: I18n.get('LABEL-FUNCTION-PUBLIC-KNOWLEDGE-SITE'),
            status: corporationData?.publicService
        },
        {
            label: I18n.get('LABEL-FUNCTION-KNOWLEDGE-BOT'),
            status: corpLimitValue.knowledgeBot
        },
        {
            label: I18n.get('LABEL-CONVERT-PDF'),
            status: corpLimitValue.convertPDF
        },
        {
            label: I18n.get('LABEL-SYNONYM-SEARCH'),
            status: corpLimitValue.synonymSearch
        },
        {
            label: I18n.get('LABEL-BATCH-COMMAND'),
            status: corpLimitValue.batchCommandService
        },
        {
            label: I18n.get('LABEL-CHAT-AI'),
            status: corpLimitValue.chatAI
        },
        {
            label: I18n.get('LABEL_FUNCTION_AI_AUTO'),
            status: corpLimitValue.aiAuto
        },
        {
            label: I18n.get('LABEL_FUNCTION_SD_AUTO'),
            status: corpLimitValue?.sdAuto
        },
        {
            label: I18n.get('LABEL-FUNCTION-TELEPHONE-AGENT'),
            status: corpLimitValue?.telephoneAgent
        },
        {
            label: I18n.get('LABEL_FUNCTION_MCP_SERVER'),
            status: corpLimitValue?.mcpServer
        },
        {
            label: I18n.get('LABEL-FUNCTION-ADVANCED-SETTINGS'),
            status: corpLimitValue.advancedOptionSettings
        },
        {
            label: I18n.get('LABEL-FUNCTION-LOG-ANALYSIS'),
            status: corpLimitValue.logAnalysis
        },
        {
            label: I18n.get('LABEL-FUNCTION-IP-RESTRICTION'),
            status: corpLimitValue?.ipRestriction
        },
        {
            label: I18n.get('LABEL-FUNCTION-MULTI-AUTH'),
            status: corpLimitValue?.multiAuth
        }
    ].filter(item => item.status === Constant.STATUS_SERVICE_PERMISSION.ON);
    // comment for now
    //hidden will be update for next sprints.
    // const optionsExternalAPICall =
    //     {
    //         label: I18n.get('LABEL_FUNCTION_EXTERNAL_WEB_API'),
    //         status: corpLimitValue?.externalWebAPI
    //     }
    return listUsingFunctions;
};

export const getOnSaleListProduct = async (API, contractProductId) => {
    let requestBody = {
        type: ProductManagementConstant.METHOD_PRODUCT.GET_LIST_PRODUCT
    };
    let res = await getListProductManagement(API, requestBody);
    if (!res.status) return;

    let listProduct = Utils.convertJSONDataToObject(res.listProduct ? res.listProduct : []);
    listProduct = listProduct.map(product => ({
        ...product,
        name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, product.name),
        increaseRate: res.increaseRate ? res.increaseRate : 0
    }));

    listProduct = listProduct.filter(
        product => Utils.isEmpty(product.deletedAt) && (product.status === ProductManagementConstant.STATUS.ON_SALES || product.id === contractProductId)
    );
    listProduct = Utils.sortListByOrderDesc(listProduct);

    return listProduct;
};

export const getOnSaleListEditionByProductId = async (API, productId, contractEditionId) => {
    let listEdition = [];
    let requestBody = {
        type: ProductManagementConstant.METHOD_PRODUCT.GET_LIST_EDITION,
        productId: productId
    };

    let res = await getListProductManagement(API, requestBody);
    if (!res.status) return listEdition;

    listEdition = Utils.convertJSONDataToObject(res.listEdition ? res.listEdition : []);
    listEdition = listEdition.map(edition => {
        const versionList = Utils.convertJSONDataToObject(edition.listVersion ? edition.listVersion : []);
        const findActiveVersion = versionList.find(ver => ver.status === ProductManagementConstant.STATUS.ON_SALES);

        return {
            ...edition,
            name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, edition.name),
            activeVersion: !Utils.isEmptyObject(findActiveVersion) ? findActiveVersion : {}
        };
    });

    listEdition = listEdition.filter(
        edition => Utils.isEmpty(edition.deletedAt) && (edition.status === ProductManagementConstant.STATUS.ON_SALES || edition.id === contractEditionId)
    );
    listEdition = Utils.sortListByOrderDesc(listEdition);

    return listEdition;
};

export const handleCustomInitUpdateContractState = (
    initData,
    setOnSaleProductList,
    setOnSaleEditionList,
    setProduct,
    setEdition,
    setVersion,
    setPaymentCycle,
    setPayment,
    setBasicSetting,
    setAdvanceSetting,
    setResetData,
    setCurrentVersionInfo,
    setCurrentPaymentCycle
) => {
    if(Utils.isEmptyObject(initData)) return;
    const initBasicSetting = {
        basicCharge: {
            price: {
                update: initData.versionData.moduleSetting.basicCharge,
                current: initData.versionData.moduleSetting.basicCharge
            }
        },
        numOfGeneralUser: {
            quantity: {
                update: initData.contractDetail.additionalUpgradeSetting.maxNumOfGeneralUser,
                current: initData.contractDetail.additionalUpgradeSetting.maxNumOfGeneralUser
            },
            price: {
                update: initData.versionData.moduleSetting.generalUserFee,
                current: initData.versionData.moduleSetting.generalUserFee
            },
            error: ''
        }
    }

    const initAdvanceSetting = {
        numOfTicket: {
            quantity: {
                update: initData.contractDetail.additionalUpgradeSetting.numOfSetTicket,
                current: initData.contractDetail.additionalUpgradeSetting.numOfSetTicket
            },
            price: {
                update: initData.versionData.moduleSetting.numberOfAdditionalTickets.price,
                current: initData.versionData.moduleSetting.numberOfAdditionalTickets.price
            },
            error: ''
        },
        numOfTicketKnowledge: {
            quantity: {
                update: initData.contractDetail.additionalUpgradeSetting.numOfSetKnowledge,
                current:initData.contractDetail.additionalUpgradeSetting.numOfSetKnowledge
            },
            price: {
                update: initData.versionData.moduleSetting.numberOfAdditionalKnowledge.price,
                current: initData.versionData.moduleSetting.numberOfAdditionalKnowledge.price
            },
            error: ''
        },
        numOfStorage: {
            quantity: {
                update: initData.contractDetail.additionalUpgradeSetting.numOfSetStorage,
                current: initData.contractDetail.additionalUpgradeSetting.numOfSetStorage
            },
            price: {
                update: initData.versionData.moduleSetting.numberOfAdditionalStorages.price,
                current: initData.versionData.moduleSetting.numberOfAdditionalStorages.price
            },
            error: ''
        },
        numberOfQACounters: {
            quantity: {
                update: initData.contractDetail.additionalUpgradeSetting.numOfSetQACounter,
                current: initData.contractDetail.additionalUpgradeSetting.numOfSetQACounter
            },
            price: {
                update: initData.versionData.moduleSetting.numberOfAdditionalQACounter.price,
                current: initData.versionData.moduleSetting.numberOfAdditionalQACounter.price
            },
            error: ''
        },
        numberOfSupportedCounters: {
            quantity: {
                update: initData.contractDetail.additionalUpgradeSetting.numOfSetSupportCounter,
                current: initData.contractDetail.additionalUpgradeSetting.numOfSetSupportCounter
            },
            price: {
                update: initData.versionData.moduleSetting.numberOfAdditionalSupportedCounter.price,
                current: initData.versionData.moduleSetting.numberOfAdditionalSupportedCounter.price
            },
            error: ''
        }
    }
    setOnSaleProductList(Utils.sortListByOrderDesc(initData.onSaleProductList));
    setOnSaleEditionList(Utils.sortListByOrderDesc(initData.onSaleEditionList));

    setProduct(initData.productData)
    setEdition(initData.editionData)
    setVersion(initData.versionData)
    setPaymentCycle(PAYMENT_CYCLE_LIST.find(item => item.code === initData.contractDetail.paymentCycle))

    const initTotalValue = 
        initData.contractDetail.additionalUpgradeSetting.maxNumOfGeneralUser * initData.versionData.moduleSetting.generalUserFee +
        initData.contractDetail.additionalUpgradeSetting.numOfSetTicket * initData.versionData.moduleSetting.numberOfAdditionalTickets.price +
        initData.contractDetail.additionalUpgradeSetting.numOfSetKnowledge * initData.versionData.moduleSetting.numberOfAdditionalKnowledge.price +
        initData.contractDetail.additionalUpgradeSetting.numOfSetStorage * initData.versionData.moduleSetting.numberOfAdditionalStorages.price +
        initData.contractDetail.additionalUpgradeSetting.numOfSetQACounter * initData.versionData.moduleSetting.numberOfAdditionalQACounter.price +
        initData.contractDetail.additionalUpgradeSetting.numOfSetSupportCounter * initData.versionData.moduleSetting.numberOfAdditionalSupportedCounter.price;
    setPayment(initTotalValue);
    setCurrentVersionInfo(initData.versionData);
    setBasicSetting(initBasicSetting);
    setAdvanceSetting(initAdvanceSetting);
    setCurrentPaymentCycle(initData.contractDetail?.currentPaymentCycle);
    setResetData({
        onSaleProduct: Utils.sortListByOrderDesc(initData.onSaleProductList),
        onSaleEdition: Utils.sortListByOrderDesc(initData.onSaleEditionList),
        product: initData.productData,
        edition: initData.editionData,
        version: initData.versionData,
        paymentCycle: PAYMENT_CYCLE_LIST.find(item => item.code === initData.contractDetail.paymentCycle),
        payment: initTotalValue,
        basicSetting: initBasicSetting,
        advanceSetting: initAdvanceSetting,
        currentVersionInfo: initData.versionData
    })
}

const handleResetData = (
    resetData,
    setOnSaleProductList,
    setOnSaleEditionList,
    setProduct,
    setEdition,
    setVersion,
    setPaymentCycle,
    setPayment,
    setBasicSetting,
    setAdvanceSetting,
    setCurrentVersionInfo
) => {
    setOnSaleProductList(resetData.onSaleProduct);
    setOnSaleEditionList(resetData.onSaleEdition);
    setProduct(resetData.product);
    setEdition(resetData.edition);
    setVersion(resetData.version);
    setPaymentCycle(resetData.paymentCycle);
    setPayment(resetData.payment);
    setBasicSetting(resetData.basicSetting);
    setAdvanceSetting(resetData.advanceSetting);
    setCurrentVersionInfo(resetData.currentVersionInfo)
}

export const closeBtnUpdateContract = (
    backCurrent,
    resetData,
    setOnSaleProductList,
    setOnSaleEditionList,
    setProduct,
    setEdition,
    setVersion,
    setPaymentCycle,
    setPayment,
    setBasicSetting,
    setAdvanceSetting,
    setIsUpdateConfirm,
    setIsShowPopupCancel,
    setCheckErr,
    setCurrentScreen,
    setCurrentVersionInfo
) => {
    handleResetData(
        resetData,
        setOnSaleProductList,
        setOnSaleEditionList,
        setProduct,
        setEdition,
        setVersion,
        setPaymentCycle,
        setPayment,
        setBasicSetting,
        setAdvanceSetting,
        setIsUpdateConfirm,
        setIsShowPopupCancel,
        setCurrentVersionInfo
    );

    setIsUpdateConfirm(false);
    setIsShowPopupCancel(false);
    setCheckErr(false);
    setCurrentScreen(backCurrent);
}

export const handleChangeVersionAndChangeSetting = (
    edition,
    setVersion,
    setBasicSetting,
    setAdvanceSetting
) => {
    if (Utils.isEmptyObject(edition) || !edition.activeVersion) return;
        const activeVersion = edition.activeVersion;
        setVersion(activeVersion);
        setBasicSetting(prev => ({
            basicCharge: {
                price: {
                    update: activeVersion.moduleSetting?.basicCharge,
                    current: prev.basicCharge.price.current
                }
            },
            numOfGeneralUser: {
                quantity: { ...prev.numOfGeneralUser.quantity },
                price: {
                    update: activeVersion.moduleSetting.generalUserFee,
                    current: prev.numOfGeneralUser.price.current
                },
                error: ''
            }
        }));
        setAdvanceSetting(prev => ({
            numOfTicket: {
                quantity: { ...prev.numOfTicket.quantity },
                price: {
                    update: activeVersion.moduleSetting.numberOfAdditionalTickets.price,
                    current: prev.numOfTicket.price.current
                },
                error: ''
            },
            numOfTicketKnowledge: {
                quantity: { ...prev.numOfTicketKnowledge.quantity },
                price: {
                    update: activeVersion.moduleSetting.numberOfAdditionalKnowledge.price,
                    current: prev.numOfTicketKnowledge.price.current
                },
                error: ''
            },
            numOfStorage: {
                quantity: { ...prev.numOfStorage.quantity },
                price: {
                    update: activeVersion.moduleSetting.numberOfAdditionalStorages.price,
                    current: prev.numOfStorage.price.current
                },
                error: ''
            },
            numberOfQACounters: {
                quantity: { ...prev.numberOfQACounters.quantity },
                price: {
                    update: activeVersion.moduleSetting.numberOfAdditionalQACounter.price,
                    current: prev.numberOfQACounters.price.current
                },
                error: ''
            },
            numberOfSupportedCounters: {
                quantity: { ...prev.numberOfSupportedCounters.quantity },
                price: {
                    update: activeVersion.moduleSetting.numberOfAdditionalSupportedCounter.price,
                    current: prev.numberOfSupportedCounters.price.current
                },
                error: ''
            }
        }));
}

export const handleChangeSelect = async (
    API,        
    selectedItem,
    setSelectedItem,
    setItemName,
    setSelectList,

    selectedProduct,
    setSelectedProduct,
    setProductList,

    setEditionList,
    setSelectedEdition,
    setVersion,
    setBasicSetting,
    setAdvanceSetting,
    contractDetail
) => {
    if (Utils.isEmpty(selectedProduct)) {
        //select product
        const [onSaleProductList, onSaleEditionList] = await Promise.all([
            getOnSaleListProduct(API, contractDetail.productId),
            getOnSaleListEditionByProductId(API, selectedItem.id, contractDetail.editionId)
        ]);
        const isExistsProduct = onSaleProductList.some(prod => prod.id === selectedItem.id && prod.status === selectedItem.status);
        if (isExistsProduct) {
            setSelectedItem(selectedItem);
            setItemName(selectedItem.name);
            setEditionList(onSaleEditionList);
            setSelectedEdition(onSaleEditionList[0]);
            handleChangeVersionAndChangeSetting(
                onSaleEditionList[0],
                setVersion,
                setBasicSetting,
                setAdvanceSetting 
            );
        } else {
            setSelectList(Utils.sortListByOrderDesc(onSaleProductList));
            setSelectedItem(onSaleProductList[0]);
            setItemName(onSaleProductList[0].name);
            const listEdition = await getOnSaleListEditionByProductId(API, onSaleProductList[0].id)
            setEditionList(listEdition);
            setSelectedEdition(listEdition[0]);
            handleChangeVersionAndChangeSetting(
                listEdition[0],
                setVersion,
                setBasicSetting,
                setAdvanceSetting 
            );
        }
    } else {
        // select edition
        const [onSaleProductList, onSaleEditionList] = await Promise.all([
            getOnSaleListProduct(API, contractDetail.productId),
            getOnSaleListEditionByProductId(API, selectedProduct.id, contractDetail.editionId),
        ]);
        const isExistsProduct = onSaleProductList.some(prod => prod.id === selectedProduct.id && prod.status === selectedProduct.status);
        if(isExistsProduct) {
            const isExistsEdition = onSaleEditionList.some(ed => ed.id === selectedItem.id && ed.status === selectedItem.status);
            if(isExistsEdition) {
                setSelectedItem(selectedItem);
                setItemName(selectedItem.name);

                handleChangeVersionAndChangeSetting(
                    selectedItem,
                    setVersion,
                    setBasicSetting,
                    setAdvanceSetting 
                );
            }else {
                setSelectList(Utils.sortListByOrderDesc(onSaleEditionList));
                setSelectedItem(onSaleEditionList[0]);
                setItemName(onSaleEditionList[0].name);

                handleChangeVersionAndChangeSetting(
                    onSaleEditionList[0],
                    setVersion,
                    setBasicSetting,
                    setAdvanceSetting 
                );
            }
        }else {
            setProductList(onSaleProductList)
            setSelectedProduct(onSaleProductList[0])
            const listEdition = await getOnSaleListEditionByProductId(API, onSaleProductList[0].id)
            setSelectList(Utils.sortListByOrderDesc(listEdition))
            setSelectedItem(listEdition[0]);
            setItemName(listEdition[0].name);
            handleChangeVersionAndChangeSetting(
                listEdition[0],
                setVersion,
                setBasicSetting,
                setAdvanceSetting 
            );
        }
    }
}

export const onClickReloadData = (setCurrentScreen, setIsShowPopUpReload, setTriggerReload, setPaymentMethod) => {
    setIsShowPopUpReload({isOpen: false, message:''});
    setCurrentScreen(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_UPDATE.SCREEN);
    setPaymentMethod(CONTRACT_SCREEN_MANAGEMENT.CONTRACT_CHOOSE_PAYMENT_CONFRIM.PAYMENT_METHOD.CREDIT);
    setTriggerReload(Date.now().toString());
};

export const renderDisplayPayment = (paymentCycle, contractDetail) => {
    if(Utils.isEmptyObject(paymentCycle)) return '';

    const displayCycle = paymentCycle.code === YEAR.CODE ? YEAR.TITLE : MONTH.TITLE;
    return contractDetail.contractStatus != CONTRACT_STATUS.ACTIVE ? `${I18n.get('LABEL-UNIT-YEN')} (税別)/${displayCycle}` : `${I18n.get('LABEL-UNIT-YEN')} (税別)`;
}

export const renderDisplayPriceCycle = (paymentCycle) => {
    if(Utils.isEmptyObject(paymentCycle)) return '';

    const displayCycle = paymentCycle.code === YEAR.CODE ? `${I18n.get('LABEL-UNIT-YEN')}/${YEAR.TITLE}` : `${I18n.get('LABEL-UNIT-YEN')}/${MONTH.TITLE}`;
    return displayCycle;
}